import { Box, Button, Container, Flex, IconButton, Text, useMediaQuery } from '@chakra-ui/react'
import parse from 'html-react-parser'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { useGetPolicyQuery } from '@core/app/api/globalApi'
import { Layout } from '@core/components/Layout/Layout'
import { useAppTheme } from '@core/utils/contexts/ThemeContext/ThemeContext'
import { hexColorEffect } from '@core/utils/helpers/hexColorEffect'

export const PolicyPage = () => {
    const { t } = useTranslation()
    const loc = useLocation()
    const { data } = useGetPolicyQuery({
        type: loc.pathname.substring(1),
    })
    const [isDesktop] = useMediaQuery('(min-width: 1230px)', {
        fallback: false,
    })
    const { appTheme } = useAppTheme()
    // const { newSettings } = appTheme?.newSettings?.general
    //     ? appTheme
    //     : {
    //           newSettings: {
    //               general: { ButtonBackground: undefined, ButtonText: undefined, BackgroundText: undefined },
    //           },
    //       }
    // const { general } = newSettings
    //
    // const ButtonBackground = general.ButtonBackground || 'EDEEF0'
    // const ButtonText = general.ButtonText || 'B0B0B0'
    // const BackgroundText = general.BackgroundText || '1A1A1A'
    const ButtonBackground = appTheme?.newSettings?.general?.ButtonBackground || 'EDEEF0'
    const ButtonText = appTheme?.newSettings?.general?.ButtonText || 'B0B0B0'
    const BackgroundText = appTheme?.newSettings?.general?.BackgroundText || '1A1A1A'

    return (
        <Layout useContainer={isDesktop ? true : false} useMobileHeader={false}>
            <Box as={'section'} py={{ base: 6, xl: 8 }} h={'full'}>
                <Container maxW={{ base: 'container.sm', xl: 'container.xl' }} h={'full'} px={{ base: 4, xl: 0 }}>
                    <Flex flexDirection={{ base: 'column', xl: 'row' }} gap={{ base: '24px', xl: '140px' }}>
                        <Box>
                            {/* <IconButton
                                icon={
                                    <svg
                                        width="36"
                                        height="36"
                                        viewBox="0 0 36 36"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle cx="18" cy="18" r="18" />
                                        <path
                                            d="M12 18L16.5 22.5M12 18L16.5 13.5M12 18H24"
                                            stroke={`#${ButtonText}`}
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                }
                                aria-label={'button back'}
                                onClick={() => history.back()}
                                bg={`#${ButtonBackground}`}
                                _hover={{ bg: hexColorEffect(`#${ButtonBackground}`, 50) }}
                            /> */}
                            <Flex mt={{ base: 6, xl: 10 }} flexDirection={'column'} gap={6}>
                                <Button
                                    variant={'link'}
                                    color={
                                        loc.pathname.substring(1) === 'privacy-policy'
                                            ? 'text.link'
                                            : `#${BackgroundText ? BackgroundText : '404040'}`
                                    }
                                    onClick={() => (location.href = '/privacy-policy')}
                                >
                                    <Text
                                        textAlign={'left'}
                                        fontSize={'sm'}
                                        fontWeight={'medium'}
                                        w={'full'}
                                        textTransform={'capitalize'}
                                        color={
                                            loc.pathname.substring(1) === 'privacy-policy'
                                                ? 'text.link'
                                                : `#${BackgroundText ? BackgroundText : '404040'}`
                                        }
                                    >
                                        {t('4636')}
                                    </Text>
                                </Button>
                                <Button
                                    variant={'link'}
                                    color={
                                        loc.pathname.substring(1) === 'user-agreement'
                                            ? 'text.link'
                                            : `#${BackgroundText ? BackgroundText : '404040'}`
                                    }
                                    onClick={() => (location.href = '/user-agreement')}
                                >
                                    <Text
                                        w={'full'}
                                        textAlign={'left'}
                                        fontSize={'sm'}
                                        fontWeight={'medium'}
                                        textTransform={'capitalize'}
                                        color={
                                            loc.pathname.substring(1) === 'user-agreement'
                                                ? 'text.link'
                                                : `#${BackgroundText ? BackgroundText : '404040'}`
                                        }
                                    >
                                        {t('4635')}
                                    </Text>
                                </Button>
                                <Button
                                    variant={'link'}
                                    color={
                                        loc.pathname.substring(1) === 'cookie-notice'
                                            ? 'text.link'
                                            : `#${BackgroundText ? BackgroundText : '404040'}`
                                    }
                                    onClick={() => (location.href = '/cookie-notice')}
                                >
                                    <Text
                                        w={'full'}
                                        textAlign={'left'}
                                        fontSize={'sm'}
                                        fontWeight={'medium'}
                                        textTransform={'capitalize'}
                                        color={
                                            loc.pathname.substring(1) === 'cookie-notice'
                                                ? 'text.link'
                                                : `#${BackgroundText ? BackgroundText : '404040'}`
                                        }
                                    >
                                        {t('4637')}
                                    </Text>
                                </Button>
                            </Flex>
                        </Box>
                        <Box
                            className={'content'}
                            maxW={'700px'}
                            color={`#${BackgroundText ? BackgroundText : '1A1A1A'}`}
                        >
                            <IconButton
                                icon={
                                    <svg
                                        width="36"
                                        height="36"
                                        viewBox="0 0 36 36"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle cx="18" cy="18" r="18" fill={`#${ButtonBackground}`} />
                                        <path
                                            d="M12 18L16.5 22.5M12 18L16.5 13.5M12 18H24"
                                            stroke={`#${ButtonText}`}
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                }
                                aria-label={'button back'}
                                onClick={() => history.back()}
                                bg={`#${ButtonBackground}`}
                                _hover={{ bg: hexColorEffect(`#${ButtonBackground}`, 50) }}
                            />

                            {data && data.data && data.data.text && parse(data.data.text)}
                        </Box>
                    </Flex>
                </Container>
            </Box>
        </Layout>
    )
}
